import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';

export default Object.freeze({
	GENERAL: `${RouteNames.BLACKLIST}-general`,
	NUMBERS: `${RouteNames.BLACKLIST}-numbers`,
	PERMISSIONS: `${RouteNames.BLACKLIST}-permissions`,
});
